import { FC, ReactNode } from 'react';
import Card from '@deliveroo/tools-component-library/dist/components/Card';

import styles from './styles.module.scss';

const CenteredCardLayout: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={styles.wrapper}>
    <Card className={styles.card}>{children}</Card>
  </div>
);

export default CenteredCardLayout;
